/* eslint-disable no-use-before-define */
import React from 'react'
import { Fields, arrayToggle, arrayFrom } from '../../../twd/twd'
import useScatterGraph from '../use-scatter-graph';
import CircleLabel from './circle-label'

export default ({ disabled=false, id } = {}) => {
    const {
        colors,
        top5Tickers,
        selectedTop5Tickers,
        setSelectedTop5Tickers
    } = useScatterGraph()

    return <React.Fragment>
        <Fields.Search
            id={id}
            dataName="corporates-scatter-graph-top5-issuers"
            placeholder={getPlaceholder(selectedTop5Tickers, "Select")}
            type="select"
            disabled={disabled}
            onSelect={(a) => {
                let arr = arrayToggle(selectedTop5Tickers, a.label)
                setSelectedTop5Tickers([...arr])
            }}
        >
        {() =>
            <React.Fragment><div>{
            top5Tickers
            .map((a,i) => {
                return {
                    label:a,
                    color: colors[5+i],
                    selected: selectedTop5Tickers.indexOf(a)>=0
                }
            })
            .map((a,i) => (
                <Fields.SearchOption
                    dataName="corporates-scatter-graph-top5"
                    item={a} key={i}>
                <Fields.CheckboxLabel
                    dataName="corporates-scatter-graph-top5-option"
                    checked={a.selected}
                    label={<CircleLabel color={a.color} label={a.label} />}
                />
                </Fields.SearchOption>)
            )
            }</div></React.Fragment>
        }
        </Fields.Search>
        </React.Fragment>
}

const getPlaceholder = (arr, emptyText) => {
    arr = arrayFrom(arr)
    let n = arr.length
    if (n===0) return emptyText

    return arr[0] + (n > 1 ? ` + ${n-1} selected` : '')
}